export default __webpack_public_path__ + "resources/icons/n330-8f24.png";